import { SsoDiscourseErrorCode, SsoDiscourseResults } from '@cf-shared/sso-discourse-interface';

/** What the client does with the server's answer to a community sign-in. */
export enum SsoExchangeOutcome {
  /** send the person on to the forum with the signed reply */
  Redirect = 'Redirect',
  /** an expected refusal: tell the person the forum is for subscribers, report nothing */
  NotSubscribed = 'NotSubscribed',
  /** a real failure: report it and show the generic message */
  Failed = 'Failed',
}

/**
 * Decide what the answer means. Kept free of Angular so it can be unit-tested
 * without a browser; `SsoService.completeExchangeAsync` acts on the result.
 */
export function decideSsoExchangeOutcome(result: SsoDiscourseResults): SsoExchangeOutcome {
  // if the server refused because the person has no subscription, that is the
  // forum's access rule working, not a failure
  if (result.error && result.errorCode === SsoDiscourseErrorCode.NotSubscribed) {
    return SsoExchangeOutcome.NotSubscribed;
  }
  // if the server refused for any other reason (including an answer with no code,
  // from a server that predates it), the refusal is a real failure
  if (result.error) {
    return SsoExchangeOutcome.Failed;
  }
  return SsoExchangeOutcome.Redirect;
}
